import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";

interface OrgAssignRowProps {
  candidateId: number;
  currentOrgId: number | null;
}

export function OrgAssignRow({ candidateId, currentOrgId }: OrgAssignRowProps) {
  const queryClient = useQueryClient();
  const { data } = useQuery({
    queryKey: ["organizations"],
    queryFn: () => api.listOrganizations(),
  });
  const [saving, setSaving] = useState(false);
  const orgs = data?.organizations ?? [];

  const handleChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newOrgId = e.target.value === "" ? null : Number(e.target.value);
    setSaving(true);
    try {
      await api.assignCandidateOrg(candidateId, newOrgId);
      queryClient.invalidateQueries({ queryKey: ["candidates"] });
    } catch (err) {
      alert(`Failed to assign org: ${(err as Error).message}`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs font-semibold text-text-secondary">Organization:</span>
      <select
        value={currentOrgId ?? ""}
        onChange={handleChange}
        disabled={saving}
        className="rounded-btn border border-border-card bg-white px-2.5 py-1 text-xs text-near-black focus:outline-none focus:shadow-focus disabled:opacity-50"
        onClick={(e) => e.stopPropagation()}
      >
        <option value="">Unassigned</option>
        {orgs.map((org) => (
          <option key={org.id} value={org.id}>{org.name}</option>
        ))}
      </select>
      {saving && <span className="text-xs text-text-secondary">Saving…</span>}
    </div>
  );
}
